/*
 * product-share.js
 * Standalone <product-share> custom element (native share / copy link) with
 * variant-URL syncing. Ported from the tt-usa main.js bundle so it can be
 * loaded on its own. Safe to include once per page.
 */
(function () {
  if (window.customElements && customElements.get('product-share')) return;

  function buildProductShareUrl(productPath, variantId, variant) {
    const vid = String(variantId),
      origin = 'undefined' != typeof window.shopUrl && window.shopUrl ? window.shopUrl : window.location.origin;
    let pathname = '',
      search = '';
    if (variant && variant.url)
      try {
        const raw = String(variant.url),
          u = 0 === raw.indexOf('http') ? new URL(raw) : new URL(raw, origin);
        pathname = u.pathname;
        search = u.search || '';
      } catch (e) {}
    pathname || (pathname = (productPath || '').split('?')[0]);
    try {
      const loc = new URL(window.location.href),
        norm = (e) => (e || '').replace(/\/$/, '') || '/';
      if (norm(pathname) === norm(loc.pathname)) {
        const out = new URL(loc.href);
        return out.searchParams.set('variant', vid), out.toString();
      }
    } catch (e) {}
    const merged = new URL(origin + pathname + (search || ''));
    return merged.searchParams.set('variant', vid), merged.toString();
  }

  function getVariantFromPicker(sectionId, variantId) {
    const picker = document.querySelector(
      'variant-selects[data-section="' + sectionId + '"], variant-swatch[data-section="' + sectionId + '"]'
    );
    if (!picker) return null;
    let variants;
    try {
      variants = JSON.parse(picker.querySelector('[type="application/json"]').textContent);
    } catch (e) {
      return null;
    }
    return variants.find((v) => String(v.id) === String(variantId)) || null;
  }

  function collectProductShareTargets(sectionId) {
    return Array.from(document.querySelectorAll('product-share[data-share-section="' + sectionId + '"]'));
  }

  function updateShareButtonUrl(target, url) {
    if (!target || !url) return;
    const byId = document.getElementById(target);
    if (byId && 'function' == typeof byId.updateUrl) return void byId.updateUrl(url);
    document.querySelectorAll('product-share[data-share-section="' + target + '"]').forEach((el) => {
      'function' == typeof el.updateUrl && el.updateUrl(url);
    });
  }

  function resolveProductShareUrlFromDom(el) {
    if (!el || !el.dataset) return null;
    const sectionId = el.dataset.shareSection;
    if ('upsell-quick-view' === sectionId) {
      const link = document.getElementById('UpsellQvFullDetailsLink');
      return link && link.href ? link.href : el.dataset.shareUrl || null;
    }
    const picker = sectionId
      ? document.querySelector(
          'variant-selects[data-section="' + sectionId + '"], variant-swatch[data-section="' + sectionId + '"]'
        )
      : null;
    let productUrl = el.dataset.productUrl || (picker ? picker.dataset.url : '') || '';
    const form = sectionId ? document.querySelector('form[id="product-form-' + sectionId + '"]') : null;
    if (!form) return el.dataset.shareUrl || null;
    const hidden = form.querySelector('input[name="id"]');
    if (!hidden) return el.dataset.shareUrl || null;
    const variant = getVariantFromPicker(sectionId, hidden.value);
    return buildProductShareUrl(productUrl, hidden.value, variant);
  }

  function syncProductShareFromVariantInput(sectionId) {
    const form = document.querySelector('form[id="product-form-' + sectionId + '"]'),
      picker = document.querySelector(
        'variant-selects[data-section="' + sectionId + '"], variant-swatch[data-section="' + sectionId + '"]'
      );
    if (!form || !picker) return;
    const hidden = form.querySelector('input[name="id"]');
    if (!hidden) return;
    const variant = getVariantFromPicker(sectionId, hidden.value);
    updateShareButtonUrl(sectionId, buildProductShareUrl(picker.dataset.url, hidden.value, variant));
  }

  function initProductShareVariantInputFallback() {
    document.querySelectorAll('variant-selects[data-section], variant-swatch[data-section]').forEach((picker) => {
      const sectionId = picker.dataset.section,
        formId = 'product-form-' + sectionId,
        form = document.querySelector('form[id="' + formId + '"]');
      if (!form || form.dataset.productShareInputBound) return;
      form.dataset.productShareInputBound = 'true';
      const hidden = form.querySelector('input[name="id"]');
      hidden &&
        hidden.addEventListener('change', () => {
          const variant = getVariantFromPicker(sectionId, hidden.value);
          updateShareButtonUrl(sectionId, buildProductShareUrl(picker.dataset.url, hidden.value, variant));
        });
    });
  }

  class ProductShare extends HTMLElement {
    constructor() {
      super();
      this._onShare = this.handleShare.bind(this);
    }
    connectedCallback() {
      const e = this.querySelector('[data-product-share-trigger]') || this.querySelector('[data-share-trigger]');
      e && !e.dataset.shareBound && ((e.dataset.shareBound = 'true'), e.addEventListener('click', this._onShare));
    }
    disconnectedCallback() {
      const e = this.querySelector('[data-product-share-trigger]') || this.querySelector('[data-share-trigger]');
      e && e.removeEventListener('click', this._onShare);
    }
    updateUrl(e) {
      'string' == typeof e && (this.dataset.shareUrl = e);
    }
    handleShare(e) {
      e.preventDefault();
      const url = resolveProductShareUrlFromDom(this) || this.dataset.shareUrl;
      if (!url) return;
      const status = this.querySelector('[data-share-status]');
      const title = this.dataset.shareTitle || document.title;
      const successMsg = this.dataset.copySuccess || '';
      const clearStatus = () => {
        status && (status.textContent = '');
      };
      navigator.share
        ? navigator
            .share({ url: url, title: title })
            .then(clearStatus)
            .catch(() => {})
        : navigator.clipboard && navigator.clipboard.writeText
        ? navigator.clipboard
            .writeText(url)
            .then(() => {
              successMsg && status && ((status.textContent = successMsg), setTimeout(clearStatus, 2500));
            })
            .catch(() => {
              window.prompt('Copy link:', url);
            })
        : window.prompt('Copy link:', url);
    }
  }

  customElements.define('product-share', ProductShare);
  window.buildProductShareUrl = buildProductShareUrl;
  window.getVariantFromPicker = window.getVariantFromPicker || getVariantFromPicker;
  window.collectProductShareTargets = collectProductShareTargets;
  window.updateShareButtonUrl = updateShareButtonUrl;
  window.resolveProductShareUrlFromDom = resolveProductShareUrlFromDom;
  window.syncProductShareFromVariantInput = syncProductShareFromVariantInput;
  window.initProductShareVariantInputFallback = initProductShareVariantInputFallback;
  'loading' === document.readyState
    ? document.addEventListener('DOMContentLoaded', initProductShareVariantInputFallback)
    : initProductShareVariantInputFallback();
})();
